import React from "react";
import { Row, Col, Card } from "antd";
import PropTypes from "prop-types";

const FormContainer = ({ formTitle, children }) => {
  return (
    <Row gutter={0}>
      <Col lg={{ span: 6, offset: 9 }} md={{ span: 8, offset: 8 }} sm={24}>
        <Card title={formTitle} style={{ width: "300", margin: "16px auto" }}>
          {children}
        </Card>
      </Col>
    </Row>
  );
};

FormContainer.propTypes = {
  formTitle: PropTypes.any,
  children: PropTypes.any
};

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/form_container/FormContainer.jsx